// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Footer_mainContainer__UiajC{
    width: 100%;
}
.Footer_container__R7sXj{
    display: flex;
    justify-content: center;
    gap: 10px;
    padding: 10px;
    flex-wrap: wrap;
    color:white;
}
.Footer_wrapperContainer__8enIZ{
    padding: 10px;
    display: flex;
    width: 100%;
    font-size:24px;
    
    flex-wrap: wrap;
    gap:20px;
}
.Footer_containerWarring__sFA6X{
    display: flex;
    justify-content: center;
    width: 50%;
    padding: 10px;
    align-items: center;


    gap:10px
}
.Footer_containerOurContacts__NJZBz{
    display: flex;
    align-items: center;
    margin:0 auto;
}
.Footer_text__27sON{
    font-family: Poppins, sans-serif;
    font-size: 15px;
    color:#bebbbb;
}
.Footer_textContact__\\+scJt{
    color:white;
    font-size: 20px;
    margin: 0 10px;
}
.Footer_textContact__\\+scJt a{
    text-decoration: none;
    color: #2caeed;
    font-size: 20px;
}
.Footer_block18__QC9R2{
    width: 50px;
    padding: 5px;
    height: 50px;
    background-color: #b72323;
    color:white;
    display: flex;
    align-items: center;
    justify-content: center;
    border:none;
    border-radius: 50%;
    font-family: Gilroy, sans-serif;
}
@media screen and (max-width: 790px) {
    .Footer_wrapperContainer__8enIZ{
        margin-left: 0px;
        flex-direction: column;
        margin-bottom: 70px;
    }
    .Footer_containerWarring__sFA6X{
        width: 100%;
    }


}`, "",{"version":3,"sources":["webpack://./src/components/Footer/Footer.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,aAAa;IACb,eAAe;IACf,WAAW;AACf;AACA;IACI,aAAa;IACb,aAAa;IACb,WAAW;IACX,cAAc;;IAEd,eAAe;IACf,QAAQ;AACZ;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,UAAU;IACV,aAAa;IACb,mBAAmB;;;IAGnB;AACJ;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,aAAa;AACjB;AACA;IACI,gCAAgC;IAChC,eAAe;IACf,aAAa;AACjB;AACA;IACI,WAAW;IACX,eAAe;IACf,cAAc;AAClB;AACA;IACI,qBAAqB;IACrB,cAAc;IACd,eAAe;AACnB;AACA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,kBAAkB;IAClB,+BAA+B;AACnC;AACA;IACI;QACI,gBAAgB;QAChB,sBAAsB;QACtB,mBAAmB;IACvB;IACA;QACI,WAAW;IACf;;;AAGJ","sourcesContent":[".mainContainer{\n    width: 100%;\n}\n.container{\n    display: flex;\n    justify-content: center;\n    gap: 10px;\n    padding: 10px;\n    flex-wrap: wrap;\n    color:white;\n}\n.wrapperContainer{\n    padding: 10px;\n    display: flex;\n    width: 100%;\n    font-size:24px;\n    \n    flex-wrap: wrap;\n    gap:20px;\n}\n.containerWarring{\n    display: flex;\n    justify-content: center;\n    width: 50%;\n    padding: 10px;\n    align-items: center;\n\n\n    gap:10px\n}\n.containerOurContacts{\n    display: flex;\n    align-items: center;\n    margin:0 auto;\n}\n.text{\n    font-family: Poppins, sans-serif;\n    font-size: 15px;\n    color:#bebbbb;\n}\n.textContact{\n    color:white;\n    font-size: 20px;\n    margin: 0 10px;\n}\n.textContact a{\n    text-decoration: none;\n    color: #2caeed;\n    font-size: 20px;\n}\n.block18{\n    width: 50px;\n    padding: 5px;\n    height: 50px;\n    background-color: #b72323;\n    color:white;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border:none;\n    border-radius: 50%;\n    font-family: Gilroy, sans-serif;\n}\n@media screen and (max-width: 790px) {\n    .wrapperContainer{\n        margin-left: 0px;\n        flex-direction: column;\n        margin-bottom: 70px;\n    }\n    .containerWarring{\n        width: 100%;\n    }\n\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainContainer": `Footer_mainContainer__UiajC`,
	"container": `Footer_container__R7sXj`,
	"wrapperContainer": `Footer_wrapperContainer__8enIZ`,
	"containerWarring": `Footer_containerWarring__sFA6X`,
	"containerOurContacts": `Footer_containerOurContacts__NJZBz`,
	"text": `Footer_text__27sON`,
	"textContact": `Footer_textContact__+scJt`,
	"block18": `Footer_block18__QC9R2`
};
export default ___CSS_LOADER_EXPORT___;
